<div class="mx-auto my-auto">
  <div class="flex py-075-rem flex-col items-center justify-center content-center">
    <div>
      <img src="/svgs/empty-firmware.svg" alt="Empty state" />
    </div>
    <div class="text-[#050809] font-semibold size-font-size-3xl mt-150-em text-center w-full">
      {{ title }}
    </div>
    <div class="text-[#292F32] mt-050-em max-w-xl size-font-weight-regular text-center">
      {{ description }}
    </div>
  </div>
</div>
